import { createSlice } from '@reduxjs/toolkit';
import { UNKNOWN_COUNTRY_CODE } from 'constants/country';
import { stateName } from './constants';
export const initialState = {
  countryCodeByIp: UNKNOWN_COUNTRY_CODE,
  countryCode: '',
  user: null,
  anon_id: '',
  platform: 'web',
  tracking_platform: 'web',
  tracker_debug_pin: null,
  languageCode: 'en',
  portalMergeSourceEnabled: false,
  facebookAppId: '',
  googleClientId: '',
  appleClientId: '',
  googleMapsApiKey: '',
  braze: {
    sdkKey: '',
    apiKey: '',
    safariWebsitePushId: '',
    sdkEndpoint: ''
  },
  isSmartAdServerAvailable: false,
  isStoriesInHomeEnabled: false,
  isWebView: false,
  isContentOnlyView: false
};

const setUser = (draft, action) => {
  const {
    user
  } = action.payload;
  draft.user = user;
};

const setUserDefaultAddress = (draft, action) => {
  const {
    address
  } = action.payload;
  if (!draft.user) return;
  draft.user.default_address = address;
};

const setFundraiserConfiguration = (draft, action) => {
  const {
    fundraiser
  } = action.payload;
  if (!draft.user) return;
  draft.user.fundraiser = fundraiser;
};

const setHasConfirmedPaymentsAccount = (draft, action) => {
  const {
    isConfirmed
  } = action.payload;
  if (!draft.user) return;
  draft.user.has_confirmed_payments_account = isConfirmed;
};

const setAnonId = (draft, action) => {
  const {
    anonId
  } = action.payload;
  draft.anon_id = anonId;
};

const setDebugPin = (draft, action) => {
  const {
    debugPin
  } = action.payload;
  draft.tracker_debug_pin = debugPin;
};

const setIsWebView = (draft, action) => {
  draft.isWebView = action.payload.isWebView;
};

const setIsContentOnlyView = (draft, action) => {
  draft.isContentOnlyView = action.payload.isContentOnlyView;
};

const setCountryCode = (draft, action) => {
  const {
    countryCode
  } = action.payload;
  draft.countryCode = countryCode;
};

const userSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setUser,
    setUserDefaultAddress,
    setFundraiserConfiguration,
    setHasConfirmedPaymentsAccount,
    setAnonId,
    setDebugPin,
    setIsWebView,
    setIsContentOnlyView,
    setCountryCode
  }
});
export const {
  actions
} = userSlice;
export const plug = {
  [stateName]: userSlice.reducer
};
export default userSlice.reducer;